import React from 'react';
import { useDispatch } from 'react-redux';
import Content from '../../Components2/Content';
import Header from '../../Components2/Header';
import { autoLogin } from '../../store/login';

function App() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(autoLogin());
    console.log('ver');
  }, [dispatch]);

  return (
    <div className="container">
      <Header />
      <Content />
    </div>
  );
}

export default App;
